import React from "react";
import { useAuth } from "../../contexts/AuthContext";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  // ── TESTING MODE: admin auth check disabled ─────────────────
  // const { user, isAuthenticated, isAuthReady } = useAuth();
  // Uncomment below to re-enable admin protection
  /*
  if (!isAuthReady) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user?.type !== "admin") return <Navigate to="/membership" replace />;
  */
  // ── END TESTING MODE ─────────────────────────────────────────

  return <>{children}</>;
};

export default AdminRoute;
